export default __webpack_public_path__ + "style-osm-night-500-d24b687087d3d632e8f7f4257f992a34.webp";